export default "__VITE_ASSET__587db42d__"